/** Tire Rack's producer (agent) code. The Tire Rack Scorecard reports only Tire Rack claims. */
export const TIRE_RACK_AGENT_CODE = 120589;
